import React, {useEffect} from 'react';
import TextField from "@mui/material/TextField";
import {Alert, Autocomplete, Stack} from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import Container from "@mui/material/Container";
import {DatePicker} from "@mui/x-date-pickers";
import 'moment/locale/en-gb';
import countries from 'i18n-iso-countries';
import enLocale from 'i18n-iso-countries/langs/en.json';
import Button from "@mui/material/Button";
import {
    useAuthenticateMutation,
    useLazyGetClubsQuery,
    useLazyPreauthQuery,
    useRegisterMutation
} from "../slices/apiSlice";
import {KeyboardArrowRight} from "@mui/icons-material";
import {useNavigate} from "react-router-dom";
import {LoadingButton} from "@mui/lab";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import {countryArray} from "../util/standards-util";

export const isEmail = (txt) => {
    return String(txt)
        .toLowerCase()
        .match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)
}

export const isValidPassword = (pwd) => {
    //const strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");
    //return strongRegex.test(pwd)
    return pwd.trim().length > 7
}

const Register = ({standalone = true, email}) => {
    const [userEmail, setUserEmail] = React.useState(email)
    const [password, setPassword] = React.useState()
    const [firstname, setFirstname] = React.useState()
    const [lastname, setLastname] = React.useState()
    const [dob, setDob] = React.useState()
    const [country, setCountry] = React.useState('')
    const [regions, setRegions] = React.useState([])
    const [club, setClub] = React.useState()
    const [clubs, setClubs] = React.useState([])
    const [validationErrors,setValidationErrors] = React.useState()
    const [hasValidPreregistration,setHasValidPreregistration] = React.useState()
    const [hasRegistrationError,setHasRegistrationError] = React.useState()

    const navigate = useNavigate()

    const [getClubs, getClubsResult]  =
        useLazyGetClubsQuery()
    const [preauth, preauthResult]  =
        useLazyPreauthQuery()

    const [register, registerResult] =
        useRegisterMutation()

    const [authenticate, authenticateResult] =
        useAuthenticateMutation()


    let cnt = 0

    const handleCountryChange = (e, value) => {
        const country = value?.key
        setCountry(country)
        setRegions(regionMap[country] ?? [])
        setClub()
        getClubs(country)
    }

    const handleDobChange = (m) => {
        setDob(m.format('YYYY-MM-DD'))
    }

    const handleClubChange = (e, value) => {
        setClub(value)
    }

    useEffect(()=>{
        if (getClubsResult.isSuccess) {
            setClubs(getClubsResult.data)
        }
    },[getClubsResult])

    useEffect(()=>{
        if (preauthResult.isSuccess) {
            const un = preauthResult.data.usernames
            if (un && un.length > 0 ) {
                //There exists at least one account with this email so give option to log in
                navigate(`/signin?cause=registerExistingAccount&email=${userEmail}`)
            }
            else {
                //there is no existing account under this email so continue with registration
                setHasValidPreregistration(true)
            }
        }
    },[preauthResult])


    const handleSubmit = (event) => {
        event.preventDefault();
        const formData = new FormData(event.currentTarget);

        if (hasValidPreregistration) {

            const data = {
                email: userEmail,
                password: password,
                firstname: firstname,
                lastname: lastname,
                dob: dob,
                sex: formData.get('sex') ? parseInt(formData.get('sex')) : undefined,
                nationality: country,
                region: formData.get('region'),
                club: club?.id,
                agreeCheck: formData.get('agreeCheck')
            }

            const errors = []

            if (data.nationality.length<1)  errors.push('Please select your nationality')
            else if (regions.length>0 && formData.get('region').length<1) errors.push('Please select your country region')

            if (!data.agreeCheck) errors.push('Please agree to the terms of service by clicking the checkbox')

            if (errors.length === 0 ) {
                setValidationErrors([])
                console.log('*** Registering user with data:')
                console.log(data)
                register(data)
            }
            else {
                setValidationErrors(errors)
            }
        }
        else {

            const data = {
                email: formData.get('email'),
                password: formData.get('password'),
                firstname: formData.get('firstname'),
                lastname: formData.get('lastname'),
            }

            const errors = []

            if (!isEmail(data.email)) errors.push('Please enter a valid email')
            //if (!isValidPassword(data.password)) errors.push('Please enter a password that is at least 8 characters long and has at least one small letter, one capital letter, one number and one special character (!@#$%^&*)')
            if (!isValidPassword(data.password)) {
                errors.push('Please enter a password that is at least 8 characters long')
            }
            else {
                if (data.password !== formData.get('password_verify')) errors.push('Passwords do not match')
            }
            if (data.firstname.length<1) errors.push('Please enter a first name')
            if (data.lastname.length<1) errors.push('Please enter a last name')


            if (errors.length === 0 ) {
                setValidationErrors([])
                setUserEmail(data.email)
                setPassword(data.password)
                setFirstname(data.firstname)
                setLastname(data.lastname)
                preauth({email:data.email})
            }
            else {
                setValidationErrors(errors)
            }
        }
    }

    useEffect(()=> {
        if (registerResult.isSuccess) {
            //Registration is successful so sign in user
            authenticate({
                username: userEmail,
                password: password,
            })
        }
        else if (authenticateResult.isError) {
            console.log("Registration error")
            console.log(authenticateResult.error)
            //TODO: show some sort of an alert here?
        }
    },[registerResult])

    useEffect(()=>{
        if (authenticateResult.isSuccess) {
            //TODO: if there is an action to complete, navigate to the appropriate page
            if (standalone) navigate('/')
        }
        else if (authenticateResult.isError) {
            //TODO: show alert?
            console.log('*** Authentication error')
            console.log(authenticateResult.error)
        }
    },[authenticateResult])


    const control = (
        <Container maxWidth="xs">
            <Box component="form" onSubmit={handleSubmit} noValidate
                 sx={{
                     bgcolor:'#ffffff',
                     p:'1.5em 1.5em',
                 }}>
                <Typography variant={'h5'} sx={{mb:'0.2em'}}>
                    Create account
                </Typography>
                {hasRegistrationError &&
                    <Alert key={++cnt} severity="error" sx={{margin: '0.5em 0 1em 0'}}>Incorrect registration details.
                        Please try again</Alert>
                }
                {validationErrors &&
                    validationErrors.map( err =>{
                        return (
                            <Alert  key={++cnt} severity="error" sx={{margin: '0.5em 0 1em 0'}}>
                                {err}
                            </Alert>
                        )
                    })
                }
                <Stack spacing={3}>
                    <Typography variant={'body1'} sx={{}}>
                        {hasValidPreregistration ? 'Please enter your sporting details' : 'Please enter your account details'}
                    </Typography>
                    <TextField variant='outlined' id="firstname" name="firstname" label="First name" required sx={{display: hasValidPreregistration ? 'none' : 'flex'}}/>
                    <TextField variant='outlined' id="lastname" name="lastname" label="Last name" required sx={{display: hasValidPreregistration ? 'none' : 'flex'}}/>
                    <TextField variant='outlined' id="email" name="email" label="Email" required defaultValue={userEmail ? userEmail : ''} sx={{display: hasValidPreregistration ? 'none' : 'flex'}}/>
                    <TextField type="password" id="password" name="password" label="Password" required sx={{display: hasValidPreregistration ? 'none' : 'flex'}}/>
                    <TextField type="password" id="password_verify" name="password_verify" required label="Verify password" sx={{display: hasValidPreregistration ? 'none' : 'flex'}}/>
                    <Autocomplete
                        disablePortal
                        selectOnFocus
                        clearOnBlur
                        handleHomeEndKeys
                        id="country"
                        name="country"
                        options={countryArray}
                        renderInput={(params) => <TextField {...params} required label="Nationality" />}
                        onChange={handleCountryChange}
                        sx={{display: hasValidPreregistration ? 'flex' : 'none'}}
                    />
                    {regions.length > 0 &&
                        <TextField id="region" name="region" label="Region" required select defaultValue=''
                                   onChange={()=>{}}
                                   sx={{textAlign:'left', display: hasValidPreregistration ? 'flex' : 'none'}}
                        >
                            {regions.map(r => <MenuItem key={r.value} value={r.value}>{r.label}</MenuItem>)}
                        </TextField>
                    }
                    <Autocomplete
                        disablePortal
                        selectOnFocus
                        clearOnBlur
                        handleHomeEndKeys
                        id="club"
                        name="club"
                        options={clubs}
                        getOptionLabel={(option) => option.name}
                        renderInput={(params) => <TextField {...params} label="Club" />}
                        onChange={handleClubChange}
                        sx={{display: hasValidPreregistration ? 'flex' : 'none'}}
                    />
                    <TextField id="sex" label="Sex" name={"sex"} select defaultValue=''
                               sx={{textAlign:'left', display: hasValidPreregistration ? 'flex' : 'none'}}
                    >
                        <MenuItem key={'m'} value={1}>Male</MenuItem>
                        <MenuItem key={'f'} value={2}>Female</MenuItem>
                    </TextField>
                    <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale={true ? "en-gb" : 'en'}>
                        <DatePicker id='dateOfBirth' name="dateOfBirth" label="Date of birth" onChange={handleDobChange} sx={{display: hasValidPreregistration ? 'flex' : 'none'}}/>
                    </LocalizationProvider>
                    <Typography variant='body2' component='div'
                                sx={{
                                    textAlign: 'left',
                                    fontSize:'.8em',
                                    fontStyle:'italic',
                                    color:'#999999'
                                }}
                    >
                        *Fields marked with an asterisk are required information
                    </Typography>
                    <Box component='div'
                         sx={{
                             display: hasValidPreregistration ? 'block' : 'none',
                             textAlign: 'left',
                             mt:'1em',
                         }}
                    >
                        <FormControlLabel control={<Checkbox id={'agreeCheck'} name={'agreeCheck'}/>} size={'small'}
                                          label={<Typography variant={'body2'} component={'div'} sx={{textAlign: 'left', fontSize:'.82em'}}>I agree with the <a href={'/terms'} target={'_blank'}>terms of use</a> of this service.</Typography>}
                        />
                    </Box>
                    {   preauthResult.isFetching ?
                        <LoadingButton loading variant="contained">
                            {hasValidPreregistration ?  'Register' : 'Next'}
                        </LoadingButton>
                        :
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            endIcon={hasValidPreregistration ? undefined : <KeyboardArrowRight/>}
                            sx={{ mt: 3, mb: 2 }}
                        >
                            {hasValidPreregistration ?  'Register' : 'Next'}
                        </Button>
                    }
                </Stack>
            </Box>
        </Container>
    )

    if (standalone) return (
        <Box>
            <Box sx={{
                minHeight: 'calc(100vh - 0px)',
                display: 'flex',
                alignItems: 'stretch',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center center',
                backgroundSize: 'cover',
                backgroundImage: 'url("/etc/home-img/photo-0003.jpg")'
            }}>
                <Box flexGrow={1} sx={{
                    display:'flex',
                    flexDirection:'column',
                    alignItems:'center',
                    justifyContent:'space-between',
                    background:'#00000077',
                }}>
                    <Box sx={{
                        py:'2em',
                    }}>
                        <Box>
                            <img src={'/etc/img/cc-stadium-logo-white.png'} style={{width:'35em'}}/>
                        </Box>
                        <Typography variant={'h3'} component={'h2'} sx={{color:'#ffffff',fontSize:'1.6rem'}} mt={1}>
                            Competition management made easy
                        </Typography>
                    </Box>
                    <Box sx={{
                        py:'2em',
                        color:'#ffffff',
                    }}>
                        <Box>
                            <img src={'/etc/img/sgp-series-logo-v3.png'} style={{width:'12em'}}/>
                            <Typography variant={'body2'}>OFFICIAL SCORING PARTNER</Typography>
                        </Box>
                    </Box>
                </Box>
                <Box flexGrow={2} sx={{
                    display:'flex',
                    flexDirection:'column',
                    justifyContent:'center',
                    alignItems:'center',
                }}>
                    {control}
                </Box>
            </Box>
        </Box>
    )
    else return control
}

const regionMap =
    {
        US: [
            {label:"Alabama", value:"AL"},
            {label:"Alaska", value:"AK"},
            {label:"Arizona", value:"AZ"},
            {label:"Arkansas", value:"AR"},
            {label:"California - Region 11", value:"CA_11"},
            {label:"California - Region 12", value:"CA_12"},
            {label:"Colorado", value:"CO"},
            {label:"Connecticut", value:"CT"},
            {label:"Delaware", value:"DE"},
            {label:"District of Columbia", value:"DC"},
            {label:"Florida", value:"FL"},
            {label:"Georgia", value:"GA"},
            {label:"Guam", value:"GU"},
            {label:"Hawaii", value:"HI"},
            {label:"Idaho", value:"ID"},
            {label:"Illinois", value:"IL"},
            {label:"Indiana", value:"IN"},
            {label:"Iowa", value:"IA"},
            {label:"Kansas", value:"KS"},
            {label:"Kentucky", value:"KY"},
            {label:"Louisiana", value:"LA"},
            {label:"Maine", value:"ME"},
            {label:"Maryland", value:"MD"},
            {label:"Massachusetts", value:"MA"},
            {label:"Michigan", value:"MI"},
            {label:"Minnesota", value:"MN"},
            {label:"Mississippi", value:"MS"},
            {label:"Missouri - Region 7", value:"MO_7"},
            {label:"Missouri - Region 10", value:"MO_10"},
            {label:"Montana", value:"MT"},
            {label:"Nebraska", value:"NE"},
            {label:"Nevada", value:"NV"},
            {label:"New Hampshire", value:"NH"},
            {label:"New Jersey", value:"NJ"},
            {label:"New Mexico", value:"NM"},
            {label:"New York - Region 2", value:"NY_2"},
            {label:"New York - Region 3", value:"NY_3"},
            {label:"North Carolina", value:"NC"},
            {label:"North Dakota", value:"ND"},
            {label:"Ohio", value:"OH"},
            {label:"Oklahoma", value:"OK"},
            {label:"Oregon", value:"OR"},
            {label:"Pennsylvania - Region 2", value:"PA_2"},
            {label:"Pennsylvania - Region 3", value:"PA_3"},
            {label:"Puerto Rico", value:"PR"},
            {label:"Rhode Island", value:"RI"},
            {label:"South Carolina", value:"SC"},
            {label:"South Dakota", value:"SD"},
            {label:"Tennessee", value:"TN"},
            {label:"Texas", value:"TX"},
            {label:"Utah", value:"UT"},
            {label:"Vermont", value:"VT"},
            {label:"Virgin Islands", value:"VI"},
            {label:"Virginia", value:"VA"},
            {label:"Washington", value:"WA"},
            {label:"West Virginia", value:"WV"},
            {label:"Wisconsin", value:"WI"},
            {label:"Wyoming", value:"WY"},
        ],

        CA:[
            {label:"AB/BC", value: "AB/BC"},
            {label:"Maritimes", value: "Maritimes"},
            {label:"ON/QC", value: "ON/QC"},
            {label:"SK/MB", value: "SK/MB"},
        ],

        AT:[
            {label:"Burgenland", value:"Burgenland"},
            {label:"Kärnten", value:"Kärnten"},
            {label:"Niederösterreich", value:"Niederösterreich"},
            {label:"Oberösterreich", value:"Oberösterreich"},
            {label:"Salzburgerland", value:"Salzburgerland"},
            {label:"Steiermark", value:"Steiermark"},
            {label:"Tirol", value:"Tirol"},
            {label:"Vorarlberg", value:"Vorarlberg"},
            {label:"Wien", value:"Wien"},
        ],

        AU: [
            {label:"New South Wales", value:"New South Wales"},
            {label:"Queensland", value:"Queensland"},
            {label:"South Australia", value:"South Australia"},
            {label:"Tasmania", value:"Tasmania"},
            {label:"Victoria", value:"Victoria"},
            {label:"West Australia", value:"West Australia"},
            {label:"Northern Territory", value:"Northern Territory"},
        ],
        DE:[
            {label:"Baden-Württemberg", value:"Baden-Württemberg"},
            {label:"Bayern", value:"Bayern"},
            {label:"Berlin", value:"Berlin"},
            {label:"Brandenburg", value:"Brandenburg"},
            {label:"Bremen", value:"Bremen"},
            {label:"Hamburg", value:"Hamburg"},
            {label:"Hessen", value:"Hessen"},
            {label:"Mecklenburg-Vorpommern", value:"Mecklenburg-Vorpommern"},
            {label:"Niedersachsen", value:"Niedersachsen"},
            {label:"Nordrhein-Westfalen", value:"Nordrhein-Westfalen"},
            {label:"Rheinland-Pfalz", value:"Rheinland-Pfalz"},
            {label:"Saarland", value:"Saarland"},
            {label:"Sachsen", value:"Sachsen"},
            {label:"Sachsen-Anhalt", value:"Sachsen-Anhalt"},
            {label:"Schleswig-Holstein", value:"Schleswig-Holstein"},
            {label:"Thüringen", value:"Thüringen"},
        ]
    };


export default Register;